import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-select-all',
    templateUrl: './select-all.component.html',
    styleUrls: ['./select-all.component.scss'],
    standalone: false
})
export class SelectAllComponent implements OnInit {
  @Input() model: UntypedFormControl;
  @Input() values = [];
  @Input() text = 'Select All';
  constructor() { }

  ngOnInit(): void {
  }


  isChecked(): boolean {
    return this.model.value && this.values.length
      && this.model.value.length === this.values.length;
  }

  isIndeterminate(): boolean {
    return this.model.value && this.values.length && this.model.value.length && this.model.value.length < this.values.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.model.setValue(this.values);
    } else {
      this.model.setValue([]);
    }
  }
}
